export default __webpack_public_path__ + "static/media/scene_08.b3403d0a.mp3";